var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.row[_vm.column.field])),_c('el-link',{attrs:{"icon":"el-icon-download"},on:{"click":_vm.downloadH5app}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }